import React, { useEffect, useState } from 'react';
import '../App.css';

const Home = ({ onNavigate }) => {

  const [fade, setFade] = useState(false);

  const portfolio = async () => {
    try {
      await fetch('https://portfoliobackend-inky.vercel.app/portfolio', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (error) {
    }
  };

  useEffect(() => {
    portfolio()
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => setFade(true), 100); // Delay for fade-in effect
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <div className="container">
        <div className={`left-section page ${fade ? 'fade-in' : ''}`}>
          <h1 className="hoverable header">HASSAAN</h1>
          <h1 className="hoverable header">AHMED</h1>
          <div className="links">
            <a
              href="/projects"
              className="hoverable link-projects"
              onClick={(e) => {
                e.preventDefault();
                onNavigate('/projects');
              }}
            >
              Projects
            </a>
            <a
              href="/contact"
              className="hoverable link-projects"
              onClick={(e) => {
                e.preventDefault();
                onNavigate('/contact');

              }}
            >
              Contact
            </a>
          </div>
        </div>
        <div className={`right-section page ${fade ? 'fade-in' : ''}`}>
          <img src='byte.png' alt="Hassaan Ahmed" className='hoverable byteimg' />
        </div>
      </div>
    </div>
  );
}

export default Home;
